module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_39-35a218cb011da7cebaab117f85a56161.png";